module.exports = __webpack_public_path__ + "img/jj_white_icon.533a2cea.png";